<template>
  <div class="foslink-page">
    <el-backtop v-if="!fromDevice"></el-backtop>
    <!-- 导航 -->
    <app-menu v-if="!fromDevice" className="mainten-menu-2" />
    <div class="solution-detail-box" :class="{ 'solution-detail-box-2': fromDevice }">
      <!-- banner -->
      <div class="sol-banner details-banner">
        <el-carousel class="banner-cal banner-cal-2" ref="carouselOne" :height="bannerHeight + 'px'"  :interval="5000" @change="changeBanner" >
            <el-carousel-item class="dis-100" v-for="(item, index) in bannerList" :key="index">
              <el-image class="dis-100 pc" :src="item.image" :fit="bannerFit"></el-image>
              <!-- <el-image @click.prevent="goBannerPage(item)" class="h5" :src="item.image" fit="fill"></el-image> -->
              <!-- <div class="w-1200 carouse-btn" v-show="index==1">
                  <span class="" @click="goBannerPage(index)">查看详情</span>
                </div> -->
            </el-carousel-item>
          </el-carousel>
        <!-- <swiper :options="swiperOption" class="banner-swiper" @swiper="onSwiper">
          <swiper-slide v-for="(item, index) in bannerList" :key="index">
            <div class="banner-slide">
              <el-image :src="item.image" alt="" fit="cover" lazy></el-image>
              <div class="banner-text">
                <p>{{ item.title }}</p>
                <div class="b-text-1" v-for="(text, textIndex) in item.subtitles" :key="textIndex">{{ text }}</div>
              </div>
            </div>
          </swiper-slide>
          <div class="swiper-pagination" slot="pagination"></div>
          <div class="swiper-button-next" slot="button-next"></div>
          <div class="swiper-button-prev" slot="button-prev"></div>
        </swiper> -->
      </div>
      <!-- 导航 -->
      <div class="main-tabs" v-if="!fromDevice">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="平台概述" name="1"></el-tab-pane>
          <el-tab-pane label="盈利模式" name="2"></el-tab-pane>
          <el-tab-pane label="适用单位" name="3"></el-tab-pane>
        </el-tabs>
      </div>
      <div class="gaishu" v-if="activeName == 1">
        <div class="main-jieshao">
          <div class="summarize-box">
            <div class="w-1200">
              <div class="sol-title">
                <p class="title-zh">平台概述</p>
                <p class="title-2">构建"物联网+智慧消防"新体系 赋能城市安全治理现代化</p>
              </div>
              <div class="summarize-content">
                <div class="summarize-left">
                  <el-image src="/images/newImg/pd-fire/fire-1-1.png" fit="contain" lazy></el-image>
                </div>
                <div class="summarize-right">
                  <div class="summarize-title">
                    <el-image src="/images/newImg/pd-fire/fire-1-2.png" fit="contain" lazy></el-image>
                    <span>智慧消防云平台</span>
                  </div>
                  <div class="summarize-text">
                    平台依托无线传感网络、云计算、大数据分析等新一代信息技术，打造"感、传、知、用"全链条智能防控体系：在感知层部署智能终端设备，对高层公共建筑、大型商业综合体、化工园区、商务楼宇、产业园区以及医疗、养老、学校等重点场所的消防设施、器材状态及人员活动进行24小时动态监测；通过多网融合传输实现消防数据的实时采集与云端汇聚；运用大数据建模和智能算法开展隐患智能诊断与风险态势研判；最终构建"监测预警-决策支持-应急指挥"的全闭环管理体系。该平台的应用将显著提升消防监督的精准性和灭火救援的响应效率，助力实现城市安全治理"一网统管"目标，切实筑牢城市安全发展防线。
                  </div>
                  <div class="summarize-subtitle">系统生态</div>
                  <div class="summarize-text">
                    除了智慧消防管理系统以外，中消云智慧安全应用体系还拥有智慧园区、智慧化工、智慧能源、智能制造、智慧水务、设备智能管理、数字化工厂、智慧电力、智慧电网、智慧燃气等众多平台应用，帮助用户搭建垂直行业的智慧系统，高效交付智慧项目。
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 体系优势 -->
          <div class="sol-pain">
            <div class="bg-img">
              <el-image src="/images/newImg/pd-fire/fire-2-bg.png" lazy></el-image>
            </div>
            <div class="w-1200">
              <div class="sol-title">
                <p class="title-zh">体系优势</p>
                <p class="title-2">通过5G物联感知、AI多源数据融合预警、动态应急响应等技术，构建从风险感知到智能调度的全链路防控体系</p>
              </div>
              <div class="sol-content">
                <el-row type="flex" :gutter="30" class="challenge-list">
                  <el-col :span="8" v-for="(item, index) in painList" :key="index">
                    <div class="challenge-one">
                      <div class="challenge-img">
                        <el-image class="img-1" :src="item.img" fit="contain" lazy></el-image>
                      </div>
                      <div class="challenge-content">
                        <div class="cha-name">{{ item.name }}</div>
                        <div class="cha-title">{{ item.title1 }}</div>
                        <div class="cha-info mb-20">{{ item.value }}</div>
                        <div class="cha-title">{{ item.title2 }}</div>
                        <div class="cha-info">{{ item.value2 }}</div>
                      </div>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </div>
          </div>
          <!-- 技术路径 -->
          <div class="sol-challenge">
            <div class="w-1200">
              <div class="sol-title">
                <p class="title-zh">核心架构及功能概括</p>
                <p class="title-2">
                  消防物联网远程监控系统，可以对各类消防信息进行采集和管理，整合城市行政、商业、安全等各领域信息，通过实战指挥、数据可视、设备管理、远程监控、模拟预警等手段，打造覆盖全域的消防安全监控、应急救援力量、调度指挥、智能化控制管理的全方位一体化消防管理平台。
                </p>
              </div>
              <div class="core-content">
                <div class="core-box-img">
                  <el-image src="/images/newImg/pd-fire/fire-3-1.png" fit="contain"></el-image>
                  <div class="core-img-text">
                    通过创新技术和系统整合，全新的消防安全管理解决方案，不仅提高了消防管理效率，还极大地降低了火灾事故带来的风险。随着智能化消防管理的推广，全方位一体化消防安全智能控制管理平台将助力消防行业更加高效、安全、智能化发展。
                  </div>
                </div>
                <div class="core-one core-1 clearfix">
                  <div class="core-img core-img-2 fr">
                    <el-image src="/images/newImg/pd-fire/fire-3-2.png" lazy></el-image>
                  </div>
                  <div class="core-text fl">
                    <div class="core-name">消防安全指数评估</div>
                    <div class="core-one-box">
                      <div class="core-title-box">
                        <span class="core-subtitle">安全评估</span>
                        <div>建筑防火·消防设施·消防安全管理·火灾风险源</div>
                      </div>
                      <div class="core-info">
                        通过对多个关键维度进行全面扫描和诊断，快速定位安全隐患，并依据规范标准标识出问题的严重程度（如高风险、异常、缺失、不合规等），采用状态标识和量化指标，精准定位隐患及其严重程度，同时关联规范要求，为风险评估和整改决策提供结构化、数据化的全面依据。
                      </div>
                    </div>
                  </div>
                  <div class="core-img core-img-1 fr">
                    <el-image src="/images/internet/jg-1.png" lazy></el-image>
                  </div>
                </div>
                <div class="core-one core-2 clearfix">
                  <div class="core-img core-img-3 fl">
                    <el-image src="/images/newImg/pd-fire/fire-3-3.png" lazy></el-image>
                  </div>
                  <div class="core-text fr">
                    <div class="core-name">隐患排查管理</div>
                    <div class="core-one-box">
                      <div class="core-title-box">
                        <span class="core-subtitle">隐患排查</span>
                        <div>地理位置·整改情况统计·整改分析·隐患分析·历史数据</div>
                      </div>
                      <div class="core-info">
                        通过监督上报、巡查上报、社会上报多种方式上传图片、视频、语音相关信息发现隐患，使用移动端进行隐患分配、整改、跟踪、督促，整改内容可上传图片、视频、语音信息。一键督促巡查负责人，落实重大安全隐患排查、隐患治理。
                      </div>
                    </div>
                  </div>
                </div>
                <div class="core-one core-3 clearfix">
                  <div class="core-img core-img-2 fr">
                    <el-image src="/images/newImg/pd-fire/fire-3-4.png" lazy></el-image>
                  </div>
                  <div class="core-text fl">
                    <div class="core-name">可视化监管</div>
                    <div class="core-one-box">
                      <div class="core-title-box">
                        <span class="core-subtitle">安全管控</span>
                        <div>设备维修情况·设备使用记录·故障维修率</div>
                      </div>
                      <div class="core-info">
                        实时监控设备的维修情况，跟踪设备的使用记录，并统计设备的故障维修率，从而进行精准的设备管理和维护；具备预测性维护功能，能够根据设备的历史数据预测未来可能出现的问题，提前采取相应的措施进行维护，确保消防设备的可靠性和稳定性。
                      </div>
                    </div>
                  </div>
                  <div class="core-img core-img-1 fr">
                    <el-image src="/images/newImg/pd-fire/fire-3-4.png" lazy></el-image>
                  </div>
                </div>

                <div class="core-one core-4 clearfix">
                  <div class="core-img core-img-3 fl">
                    <el-image src="/images/newImg/pd-fire/fire-3-5.png" lazy></el-image>
                  </div>
                  <div class="core-text fr">
                    <div class="core-name">多模态AI视频系统</div>
                    <div class="core-one-box">
                      <div class="core-title-box">
                        <span class="core-subtitle">远程监控</span>
                        <div>实时报警·智能报警·隐患整改·安全检查·电气监控</div>
                      </div>
                      <div class="core-info">
                        通过实时采集监控现场的各类信号与图像信息，并及时传送到远程监控中心，通过对海量信息的数据分析应用，结合多种成熟算法（烟火识别、热点分析、通道堵塞、人员离岗等）进行精准识别，对重点部位、高发时段进行重点防控。
                      </div>
                    </div>
                  </div>
                </div>

                <div class="core-one core-5 clearfix">
                  <div class="core-img core-img-2 fr">
                    <el-image src="/images/newImg/pd-fire/fire-3-7.png" lazy></el-image>
                  </div>
                  <div class="core-text fl">
                    <div class="core-name">消防巡查巡检 </div>
                    <div class="core-one-box">
                      <div class="core-title-box">
                        <span class="core-subtitle">巡查巡检</span>
                        <div>计划生成·信息上报·任务分配·整改验收</div>
                      </div>
                      <div class="core-info">
                        针对巡查任务，可准确锁定巡查人员、相关设备、任务时间，进行巡查信息上报、结果受理、任务分配、任务整改、处置反馈、结果验收全流程的闭环处理。更可通过手持终端PDA随时便捷地执行巡检任务，做到巡查管理的统筹化、信息化、智能化。
                      </div>
                    </div>
                  </div>
                  <div class="core-img core-img-1 fr">
                    <el-image src="/images/newImg/pd-fire/fire-3-7.png" lazy></el-image>
                  </div>
                </div>

                <div class="core-one core-6 clearfix">
                  <div class="core-img core-img-3 fl">
                    <el-image src="/images/newImg/pd-fire/fire-3-8.png" lazy></el-image>
                  </div>
                  <div class="core-text fr">
                    <div class="core-name">消控室远程控制</div>
                    <div class="core-one-box">
                      <div class="core-title-box">
                        <span class="core-subtitle">远程监控</span>
                        <div>控制指令远程下发·视频实时联动·主机联动多、总线设备</div>
                      </div>
                      <div class="core-info">
                        通过用户信息传输装置接入消防主机，实时采集火警、故障等数据。支持对行业内超60%的消防设备（不分厂家及设备型号）的远程启停手自动切换、消音、复位、总线盘和多线盘控制，火警确认时间缩短50%，故障处理效率提升70%；双岗变单岗，有效降低消控室年均人力成本。
                      </div>
                    </div>
                  </div>
                </div>

                <div class="core-one core-7 clearfix">
                  <div class="core-img core-img-2 fr">
                    <el-image src="/images/newImg/pd-fire/fire-3-9.png" lazy></el-image>
                  </div>
                  <div class="core-text fl">
                    <div class="core-name">消防数据分析</div>
                    <div class="core-one-box">
                      <div class="core-title-box">
                        <span class="core-subtitle">数据分析</span>
                        <div>异常状态·接入设备·隐患统计·值班信息</div>
                      </div>
                      <div class="core-info">
                        全方位针对设备类型、设备状态、隐患状态、报警趋势等数据进行实时统计、信息反馈，将数据通过图文形式进行汇总呈现，并定期生成统计报表以作参考分析。
                      </div>
                    </div>
                  </div>
                  <div class="core-img core-img-1 fr">
                    <el-image src="/images/newImg/pd-fire/fire-3-9.png" lazy></el-image>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="summarize-box main-function">
        <div class="w-1200">
          <div class="sol-title">
            <p class="title-zh">我们能提供</p>
            <p class="title-2">全协议适配·多源数据融合·生态协同，引领消防管理智能革新</p>
          </div>
          <div class="summarize-content summarize-content-2">
            <div class="summarize-left">
              <el-image src="/images/newImg/pd-fire/fire-5-1.png"></el-image>
            </div>
            <div class="summarize-right">
              <div class="summarize-title-2">
                <span>开放互联，全域兼容——打造无界融合的智慧消防生态</span>
              </div>
              <div class="summarize-text">
                全协议适配、全场景覆盖、全生态兼容，能与多种消防设备无缝对接。平台支持多种通信协议，可快速接入设备，通过接口对接第三方系统，构建消防数据枢纽。
              </div>
              <div class="summarize-title-2 mt-20">
                <span>平台搭建与服务</span>
              </div>
              <div class="summarize-text">
                低成本搭建合作商自己的消防物联网平台，提供专业的售后及平台维护服务，使得客户能低成本零风险开展智慧消防业务。
              </div>
              <div class="summarize-title-2 mt-20">
                <span>平台特点</span>
              </div>
              <div class="summarize-text">
                独立域名丨独立品牌丨自选设备丨本地部署丨数据对接
              </div>
            </div>
          </div>
        </div>
      </div> -->
        <!-- 部署方式  -->
        <div class="sol-deploy main-bushu">
          <div class="bg-img">
            <el-image src="/images/newImg/pd-fire/fire-4-bg.png" lazy></el-image>
          </div>
          <div class="w-1200">
            <div class="sol-title">
              <p class="title-zh">部署方式</p>
              <p class="title-2">SAAS的弹性与本地部署的安全性相结合，实现灵活高效且安全的部署方式</p>
            </div>
            <div class="deploy-content">
              <div class="deploy-one">
                <div class="deploy-img">
                  <el-image src="/images/newImg/pd-fire/fire-4-1.png" lazy></el-image>
                </div>
                <div class="deploy-text">
                  <el-image src="/images/newImg/pd-fire/fire-4-3.png" lazy></el-image>
                  <div class="deply-title">SaaS</div>
                  <div class="deply-info">云服务器</div>
                  <div class="deply-info">无需购买软件和硬件，无需IT维护</div>
                  <div class="deply-info">前期投资成本低</div>
                  <div class="deply-info">系统自动更新，可免费享受最新功能</div>
                  <div class="deply-info">按年付费，快速部署</div>
                </div>
              </div>
              <div class="deploy-one">
                <div class="deploy-img">
                  <el-image src="/images/newImg/pd-fire/fire-4-2.png" lazy></el-image>
                </div>
                <div class="deploy-text">
                  <el-image src="/images/newImg/pd-fire/fire-4-4.png" lazy></el-image>
                  <div class="deply-title">本地部署</div>
                  <div class="deply-info">自建服务器，数据存储在本地</div>
                  <div class="deply-info">软件永久授权</div>
                  <div class="deply-info">个性化需求定制程度更高</div>
                  <div class="deply-info">灵活性和自主性更高</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="yingli" v-if="activeName == 2">
        <div class="w-1200">
          <div class="yingli-1">
            <div class="yingli-text">
              <div class="text-title">
                <el-image src="/images/internet/jg-icon-5.png" fit="contain" lazy></el-image><span>客户投入</span>
              </div>
              <div class="text-content">
                <p>智慧消防远程值守中心，建设在城市周边区域，租50平米左右的房间作为服务中心，极简装修+一块55寸大屏，预计房租2.2~3.6万元/年。</p>
                <p>7*24值守，需雇佣3~4人，人员工资4000~5000元/人/月。</p>
                <p>智慧消防远程值守系统费用，10000~20000元/套，包含三年平台服务费。</p>
                <p class="mt-10">一次性投入成本（万元）</p>
                <div class="text-sum">合计3.5+(2.2~3.6)+(0.4~0.5)*4+(1~2)≈8.3~17.1万</div>
              </div>
              <div>
                <el-image src="/images/internet/jg-12.png" fit="contain" lazy></el-image>
              </div>
            </div>
            <div class="yingli-img">
              <el-image src="/images/internet/jg-9.png" fit="contain"></el-image>
            </div>
          </div>
          <div class="yingli-1 yingli-2">
            <div class="yingli-img">
              <el-image src="/images/internet/jg-10.png" fit="contain" lazy></el-image>
            </div>
            <div class="yingli-text">
              <div class="text-title">
                <el-image src="/images/internet/jg-icon-6.png" fit="contain" lazy></el-image><span>客户产出</span>
              </div>
              <div class="text-content">
                <p>客户通过对甲方用户的消防控制室进行远程照管+反向控制+报警提醒+定期上门培训、维护。可向甲方用户，按照0.2元/平米或固定收费20000-30000元/年收取消防安全远程值守费用。</p>
              </div>
              <div>
                <el-image src="/images/internet/jg-11.png" fit="contain" lazy></el-image>
              </div>
              <div class="">
                <div class="jia-fang-1">甲方客户包括</div>
                <div class="jia-fang-2">
                  <span>医院</span>
                  <span>学校</span>
                  <span>养老院</span>
                  <span>企事业单位</span>
                  <span>政府大楼</span>
                  <span>商业写字楼</span>
                  <span>大型商场</span>
                  <span>工业园区 </span>
                  <span>科技园区 </span>
                  <span>化工园区 </span>
                  <span>... </span>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
      <div class="danwei" v-if="activeName == 3">
        <!--消防值守痛点  -->
        <div class="danwei-1">
          <div class="w-1200">
            <div class="sol-title">
              <p class="title-zh">消防值守痛点</p>
              <p class="title-2">消防基础设施薄弱、消防监管缺乏手段、智慧消防投资大、周期长、智慧消防重建设轻服务等...</p>
            </div>
            <div class="danwei-1-img">
              <el-image src="/images/internet/jp-2.png" fit="contain" lazy></el-image>
            </div>
          </div>
        </div>
        <!-- 价值体现 -->
        <div class="danwei-2">
          <div class="w-1200">
            <div class="sol-title">
              <p class="title-zh">价值体现</p>
              <p class="title-2">我们以“防火服务运营商”为定位，通过全生命周期运维、24小时智慧值守、大数据隐患跟踪及反向控制等一体化服务，彻底杜绝烂尾工程，并为客户提供最终的火情安全保障。</p>
            </div>
            <div class="danwei-2-con">
              <el-row type="flex" :gutter="20">
                <el-col :span="12" v-for="(item, index) in valueList" :key="index">
                  <div class="dw-col-one">
                    <div class="dw-2-title">
                      <el-image :src="item.img" lazy></el-image>
                      <span>{{ item.title }}</span>
                    </div>
                    <div class="dw-2-con">{{ item.content }}</div>
                  </div>
                </el-col>
              </el-row>
            </div>
          </div>
        </div>
        <!-- 使用单位 -->
        <div class="danwei-3">
          <div class="w-1200">
            <div class="sol-title">
              <p class="title-zh">适用单位</p>
              <p class="title-2">智慧消防值守服务通过人技结合与政策支持，为维保、物业、工程公司及集团客户等带来降本、增收、提效和安全保障等多重价值。</p>
            </div>
            <div class="dw-3-main">
              <div class="main-one" :class="index % 2 == 1 ? 'one-left' : 'one-right'"
                v-for="(item, index) in useCompany" :key="index">
                <div class="main-o-img">
                  <el-image :src="item.img" fit="contain" lazy></el-image>
                </div>
                <div class="main-o-title">
                  <div class="main-t-1">{{ item.title }}</div>
                  <p v-for="(value, key) in item.content" :key="key">{{ value }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
    <app-footer v-if="!fromDevice" />
  </div>
</template>

<script>
import AppMenu from "@/views/components/AppMenu"
import AppFooter from "@/views/components/AppFooter"
import { metaInfo } from "@/utils"
export default {
  metaInfo: metaInfo,
  components: { AppMenu, AppFooter },
  props: ['fromDevice'], //fromDevice 来自产品中心
  data() {
    return {
      activeName: '1',
      // Banner 轮播图数据
      bannerHeight: 400,
      bannerFit: 'contain',
      bannerList: [
        {
          image: '/images/internet/banner1.jpg',
          title: '"物联网+智慧消防"新体系',
          subtitles: [
            '安全可靠的私有化部署',
            '海量的第三方设备快速对接',
            '客户专属定制的运营平台'
          ]
        },
        {
          image: '/images/internet/banner2.jpg',
          title: '智慧消防云平台',
          subtitles: [
            '24小时动态监测',
            '智能预警与风险研判',
            '全闭环管理体系'
          ]
        },
        {
          image: '/images/internet/banner3.jpg',
          title: '消防安全智能管控',
          subtitles: [
            '多模态AI视频系统',
            '远程监控与反向控制',
            '数据可视化分析'
          ]
        }
      ],
      painList: [
        {
          img: '/images/newImg/pd-fire/fire-2-1.png',
          name: '多协议/多品牌设备对接',
          title1: '全域物联终端：',
          value: '烟感、温感、电气火灾探测器、消防压力变送计、消防液位传感器、可燃气体探测器、AI火焰识别摄像头、用户信息传输装置。',
          title2: '更多协议支持：',
          value2: 'NB-IOT CAT1 LORA  ZIGBEE MODBUS MQTT等各种协议。'
        },
        {
          img: '/images/newImg/pd-fire/fire-2-2.png',
          name: '消防物联网监管平台',
          title1: '持续迭代的平台功能：',
          value: '物联设备监测预警系统、消防巡检、消防维保、消防培训、设备管理、消防控制室远程监控及反向控制等业务模块，并进行持续迭代更新。',
          title2: '售后/托管：',
          value2: '提供全方位的产品及平台售后服务，7X24小时技术支持，提供低成本的平台托管服务。 '
        },
        {
          img: '/images/newImg/pd-fire/fire-2-3.png',
          name: '消防值守业务模式',
          title1: '安全照管服务：',
          value: '通过物联设备和照管平台的预警服务，低成本打造区域消防安全照管值守服务，更高效和快捷的发现企业消防隐患并进行处置。',
          title2: '优势：',
          value2: '投入少，收益高，消防隐患及时处理，企业消防安全风险大幅度减少。'
        }
      ],
      
      valueList: [
        {
          img: '/images/internet/jg-icon-1.png',
          title: '用服务替代产品',
          content: '我们不是产品的销售商，我们是防火服务的运营商，我们提供项目全生命周期的运营维护服务，杜绝烂尾工程。'
        },
        {
          img: '/images/internet/jg-icon-2.png',
          title: '搭建智慧消防远程值守服务中心',
          content: '7*24小时值守，加强火情预警；线下门店7*24小时值守，让守护更进一步。'
        },
        {
          img: '/images/internet/jg-icon-3.png',
          title: '搭建线上监控和隐患反馈及跟踪平台',
          content: '用互联网大数据解决问题：线上进行火灾隐患防控及监控，以及用户需求匹配解决，把政府相关部门关注的人力不及的工作线上化，智能化。'
        },
        {
          img: '/images/internet/jg-icon-4.png',
          title: '反向控制',
          content: '对消防控制室消防主机反向控制，实现发生真实火情使，为甲方用户提供最后一道消防安全保障。'
        }
      ],
      useCompany: [
        {
          img: '/images/internet/jg-4.png',
          title: '维保公司',
          content: [
            '假设第一年收取业主单位一套物联网设备+智慧消防平台+反向控制报警主机等各一台硬件设备及安装调试费24000-29000元，毛利润率在58%-65%。',
            '第二年起收取业主单位按照0.2元/平米或值守维护费20000-30000元/年，作为全年消防安全照管服务费，客户毛利润率在75%-83%。',
            '首先、客户通过对业主单位提供照管服务，可以持续多年收取照管服务费。加深跟客户绑定，从而争取消防改造及其他项目机会。',
            '其次、客户可以充分利用当地单人值守等相关国家、地区政策文件支持拓展业务范围，把自己手中的消防维保客户、消防工程客户、消防改造客户转化为照管客户。从而，迅速扩大照管客户规模，形成规模效应，降低成本，提升服务质量，持续收取相对客观的照管费用。'
          ]
        },
        {
          img: '/images/internet/jg-5.png',
          title: '物业公司',
          content: [
            '通过提供值守维护服务，实时发现消除火灾隐患，准确掌握火情报警，及时安排消防安全负责人员处置火情，大幅降低火宅发生率，显著提升业主满意度。',
            '根据当地单人值守等相关国家、地区政策文件，通过加装“物联网设备+智慧消防平台+反向控制报警主机”可大幅减少消防控制室值班人员。',
            '以一个消控室为例：依照原有政策，消防控制室实行24小时值班制度，每天2班，每班2人，则需要4名值班员，且都需具备消防职业资格证书。上述人员每人每年成本至少为5至6万元，依据当地消控室单人值班政策，一个消控室只需1人值班。一个物业项目每年将节省人工成本10至12万元，将给物业公司带来巨大经济效益。同时，也提升了物业公司消防安全管理能力和效率。'
          ]
        },
        {
          img: '/images/internet/jg-6.png',
          title: '工程公司',
          content: [
            '可通过公司目前已落地的消防工程项目、消防改造工程所积累的甲方业主资源，以及其它领域的甲方合作资源，系统性推进消防设施值守与维护服务，进一步为传统消防工程业务赋能。通过将“建设–维护–运营”环节打通，实现传统消防工程与智慧消防值守运维服务的深度融合，既延伸业务链条、拓展服务边界，也可依托智能化手段提升服务响应效率与设备管理水平。该模式不仅有助于构建“工程+服务”双轮驱动的新业务格局，增强客户对公司整体解决方案的依赖度和满意度，还能通过持续的服务输出形成稳定收益来源，进一步提升客户粘性，为公司在消防服务市场中建立差异化竞争优势、实现业务增值与品牌升级提供坚实支撑。'
          ]
        },
        {
          img: '/images/internet/jg-7.png',
          title: '集团公司',
          content: [
            '如国内或外资大型集团公司，可通过智慧消防远程值守中心，可实现集团内部消防隐患和报警数据及时上传，可提高火灾隐患感知能力和安全监管的手段，可提升集团内部消防安全管理能力和处置能力，可有效将火灾隐患消灭在“萌芽”状态，最大限度避免因突发火灾事件对集团造成的财产损失，降低安全风险成本。',
            '同时，根据当地单人值守等相关国家、地区政策文件，通过加装“物联网设备+智慧消防平台+反向控制报警主机”可大幅减少消防控制室值班人员，为集团节省大量人员开支。'
          ]
        },
        {
          img: '/images/internet/jg-8.png',
          title: '第三方专业消防值守公司',
          content: [
            '我们通过搭建智慧消防远程值守中心，构建“线上下单+线下服务”一体化响应机制，面向已有甲方业主提供覆盖隐患排查评估、定制化方案设计、专业安装实施与长效运营维护的全流程服务闭环，确保火灾隐患能够被实时监测、快速研判与高效处置。该体系有效整合物联网、大数据与人工智能等关键技术，推动“人防+技防”深度融合，不仅大幅提升消防安全管理的精准性与响应效率，更逐步构建起一套科学、可持续的区域火灾隐患防控系统，从而降低安全事故发生概率，减轻甲方运维压力，真正实现“让智慧消防更简单，让业主安全无忧”的服务愿景。'
          ]
        }
      ]
    }
  },
  mounted() {
    let _this = this
    // console.log('mounted 执行了', $(window).scrollTop());

    // 直接添加滚动监听，不使用 setTimeout
    window.addEventListener('scroll', _this.handleScroll);
    window.addEventListener('resize', _this.calImgHeight)
    this.calImgHeight()
  },
  beforeDestroy() {
    let _this = this
    window.removeEventListener('scroll', _this.handleScroll);
    window.removeEventListener('resize', _this.calImgHeight)
  },
  created() { },
  methods: {
    calImgHeight(){
      let ratio = 1920/450
      let pageWidth = $(window).width()
      let bannerHeight = pageWidth/ratio
      let bannerFit = 'contain'
      if(pageWidth<900){
        bannerHeight = 150
        bannerFit = 'cover'
        $('.banner-cal').removeClass('banner-cal-2')
      }
      this.bannerFit = bannerFit
      this.bannerHeight = bannerHeight
    },
    changeBanner(index) {
      this.bannerIndex = index
    },
    handleScroll() {
      let _this = this
      // console.log(123);
      // 原有的逻辑（注释掉的部分）
      let bannerHeight = $('.details-banner').height()
      let pageScrollTop = $(document).scrollTop()
      // console.log('高度', bannerHeight, pageScrollTop);
      if (pageScrollTop > bannerHeight - 20) {
        // $('.mainten-menu-2').css('display', 'none')
        $('.mainten-menu-2').addClass('menu-hidden')
        $('.main-tabs').addClass('main-tabs-2')
      } else {
        // $('.mainten-menu-2').css('display', 'block')
        $('.mainten-menu-2').removeClass('menu-hidden')
        $('.main-tabs').removeClass('main-tabs-2')
      }
      // _this.judgeType()
    },
    initActive(type) {
      let bannerHeight = $('.details-banner').height()
      let height1 = $('.main-jieshao').height()
      let height2 = $('.main-function').height()
      let height3 = $('.main-bushu').height()

      if (type == '1') {
        $(document).scrollTop(bannerHeight)
      } else if (type == '2') {
        let newHeight = bannerHeight + height1
        $(document).scrollTop(newHeight)
      } else if (type == '3') {
        let newHeight2 = bannerHeight + height1 + height2
        $(document).scrollTop(newHeight2)
      }
    },
    judgeType() {
      let bannerHeight = $('.details-banner').height()
      let height1 = $('.main-jieshao').height()
      let height2 = $('.main-function').height()
      let height3 = $('.main-bushu').height()
      let newHeight1 = bannerHeight
      let newHeight2 = bannerHeight + height1
      let newHeight3 = bannerHeight + height1 + height2
      let pageScrollTop = $(document).scrollTop() + 10
      // console.log(pageScrollTop, newHeight2);
      // console.log('333=', pageScrollTop, newHeight3);
      if (pageScrollTop > 0 && pageScrollTop < newHeight2) {
        this.activeName = '1'
      } else if (pageScrollTop > newHeight2 && pageScrollTop < newHeight3) {
        this.activeName = '2'
      } else if (pageScrollTop > newHeight3) {
        this.activeName = '3'
      }
    },
    handleClick() {
      let bannerHeight = $('.details-banner').height()
      let pageScrollTop = $(document).scrollTop()
      if (pageScrollTop > bannerHeight - 20) {
        $(document).scrollTop(bannerHeight+40)
      }
      
      // this.initActive(this.activeName)
    },

    // 测试方法：手动触发滚动事件
    testScroll() {
      console.log('手动测试滚动事件');
      this.handleScroll();
    },
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/smartFire.scss';
</style>


// WEBPACK FOOTER //
// src/views/product/smartFire.vue